import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { disabledFormStyles } from "./DisabledFormStyles";
import { CSS_COLORS } from "../../../../../../styles/styles-css-variables";

const textFieldFormWrapperStyles = css`
  display: flex;
  position: relative;

  --pad: 16px;

  &.with-right-padding {
    input {
      padding-right: 32px;
      text-overflow: ellipsis;
    }
  }

  &.variant-white {
    --bg-color: ${CSS_COLORS.GrayLight2024};
    --text-color: ${CSS_COLORS.Black};
    --text-placeholder-color: ${CSS_COLORS.Grey3};
    --disabled-color: ${CSS_COLORS.Black} --border-color: ${CSS_COLORS.Green};
    --bg-error: ${CSS_COLORS.GrayLight2024};
    --text-error: ${CSS_COLORS.RedCustom};

    &.has-error {
      --border-color: ${CSS_COLORS.RedCustom};
    }
  }

  &.variant-outline {
    --bg-color: ${CSS_COLORS.Green};
    --text-color: ${CSS_COLORS.White};
    --disabled-color: ${CSS_COLORS.White};
    --text-placeholder-color: ${CSS_COLORS.Grey0};

    --border-color: ${CSS_COLORS.White};
    --bg-error: ${CSS_COLORS.RedTransparentCustom};
    --text-error: ${CSS_COLORS.RedCustom};

    &.has-error {
      --border-color: ${CSS_COLORS.RedTransparentCustom};
    }
  }

  &:focus-within,
  &.placeholder-visible {
    .placeholder {
      display: block;

      color: var(--text-color);
      transform: translate(0, -12px) scale(0.75);
      transform-origin: center left;
      transition: transform 0.2s ease-out;

      height: auto;
    }
  }

  .placeholder {
    transition: transform 0.15s ease-out;
    transform-origin: center left;
  }

  &.disabled {
    ${disabledFormStyles};
  }

  input {
    border-radius: 8px; // ios safari
  }
`;

export const StyledElementWrapper = styled.div(textFieldFormWrapperStyles);
